import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Pk } from '../../models/pk.model';
import { Api } from '../util/api';

@Injectable()
export class AnalyticsService {
  private endpoint: string = 'analytics';

  constructor(private api: Api) {
  }

  getAlertThicknessForecast(location: Pk): Observable<any> {
    return this.api.get(`${this.endpoint}/pks/alertThicknessForecast`, this.getLocationParams(location));
  }

  getWearStatePercentages(): Observable<any> {
    return this.api.get(`${this.endpoint}/pks/wearStatePercentages`);
  }

  getWearValuesForecast(location: Pk): Observable<any> {
    return this.api.get(`${this.endpoint}/pks/wearValuesForecast`, this.getLocationParams(location));
  }

  getWearValuesForecastFromDB(location: Pk): Observable<any> {
    return this.api.get(`${this.endpoint}/pks/wearValuesForecastFromDB`, this.getLocationParams(location));
  }

  private getLocationParams(location: Pk): HttpParams {
    return new HttpParams()
      .set('line', location.line.id.toString())
      .set('number', location.number.toString())
      .set('way', location.way)
      .set('potential', location.potential);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/analytics.service.ts